<template>
  <ContentWrap>
    <el-form :inline="true" class="-mb-15px">
      <el-form-item>
        <el-button v-hasPermi="['market:category:create']" type="primary" @click="openForm()">
          <Icon icon="ep:plus" />新增分类
        </el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="位标记ID" prop="id" width="100" />
      <el-table-column label="名称" prop="name" min-width="140" />
      <el-table-column label="别名" prop="alias" width="120" />
      <el-table-column label="排序" prop="sort" width="80" />
      <el-table-column label="状态" width="90">
        <template #default="{ row }">{{ row.status === 0 ? '启用' : '停用' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button v-hasPermi="['market:category:update']" link type="primary" @click="openForm(row)">
            编辑
          </el-button>
          <el-button v-hasPermi="['market:category:delete']" link type="danger" @click="handleDelete(row.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </ContentWrap>

  <Dialog v-model="formVisible" :title="formData.id ? '编辑分类' : '新增分类'" width="480px">
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="90px">
      <el-form-item label="位标记ID" prop="id">
        <el-input-number v-model="formData.id" :min="1" :disabled="!!editId" class="!w-full" />
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" />
      </el-form-item>
      <el-form-item label="别名">
        <el-input v-model="formData.alias" />
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="formData.sort" :min="0" class="!w-full" />
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="formData.status">
          <el-radio :value="0">启用</el-radio>
          <el-radio :value="1">停用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import * as CategoryApi from '@/api/market/category'
import type { MarketCategoryVO } from '@/api/market/category'

defineOptions({ name: 'MarketCategory' })

const message = useMessage()
const loading = ref(false)
const list = ref<MarketCategoryVO[]>([])
const formVisible = ref(false)
const editId = ref<number>()
const formRef = ref()
const formData = ref<MarketCategoryVO>({ status: 0, sort: 0 })
const rules = {
  id: [{ required: true, message: '位标记 ID 必填', trigger: 'blur' }],
  name: [{ required: true, message: '名称必填', trigger: 'blur' }]
}

const load = async () => {
  loading.value = true
  try {
    list.value = await CategoryApi.getMarketCategoryList()
  } catch (e: any) {
    message.error(e?.message || '加载分类失败，请确认后端已重启')
  } finally {
    loading.value = false
  }
}

const openForm = (row?: MarketCategoryVO) => {
  editId.value = row?.id
  formData.value = row ? { ...row } : { status: 0, sort: 0 }
  formVisible.value = true
}

const submitForm = async () => {
  await formRef.value?.validate()
  if (editId.value) {
    await CategoryApi.updateMarketCategory(formData.value)
    message.success('已更新')
  } else {
    await CategoryApi.createMarketCategory(formData.value)
    message.success('已创建')
  }
  formVisible.value = false
  await load()
}

const handleDelete = async (id: number) => {
  await message.delConfirm()
  await CategoryApi.deleteMarketCategory(id)
  message.success('已删除')
  await load()
}

onMounted(load)
</script>
